import React, { useState, useRef, forwardRef } from 'react';
import { Box, Card, CardContent, Typography, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { formatearDateAFechaDiaMesUY, formatearDateAHorasUY, getDiaSemana } from 'utils/utilities';
import './FichaEspectaculo.scss';
import { theme } from 'theme/theme';
import { Fecha, FuncionConDate } from 'utils/models/types';
import { anchoMaxForms } from 'utils/constants';

interface FuncionesProps {
  funcionId?: number;
  funcionesConFechas: FuncionConDate[];
  onDateSelect: (funcion: FuncionConDate) => void;
}

const CarouselFunciones = forwardRef<HTMLDivElement, FuncionesProps>(
  ({ funcionId, funcionesConFechas, onDateSelect }, ref) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const fechasFunciones: Fecha[] = funcionesConFechas.map(funcion => funcion.Fecha);

    const maxIndex = fechasFunciones?.length - 1;
    const funcionesRef = useRef<HTMLDivElement>(null);
    const [indexFecha, setIndexFecha] = useState(-1);
    const NUMERO_MAX_FUNCIONES_ANCHO_PAG = 5;

    const handleNext = () => {
      setCurrentIndex(prevIndex => (prevIndex < maxIndex ? prevIndex + 1 : prevIndex));
      funcionesRef.current?.scrollBy({ left: funcionesRef.current.clientWidth, behavior: 'smooth' });
    };

    const handlePrev = () => {
      setCurrentIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
      funcionesRef.current?.scrollBy({ left: -funcionesRef.current.clientWidth, behavior: 'smooth' });
    };

    const handleOnClick = (funcion: FuncionConDate, i: number) => {
      onDateSelect(funcion);
      setIndexFecha(i);
    };

    return (
      <Box
        ref={ref}
        sx={{
          position: 'relative',
          maxWidth: anchoMaxForms,
          mx: 'auto',
          overflowX: 'auto',
        }}
      >
        {fechasFunciones.length > NUMERO_MAX_FUNCIONES_ANCHO_PAG && (
          <>
            <IconButton
              onClick={handlePrev}
              sx={{
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                bgcolor: 'rgba(255, 255, 255, 0.7)',
              }}
              disabled={currentIndex === 0}
            >
              <ArrowBackIosIcon />
            </IconButton>
            <IconButton
              onClick={handleNext}
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                bgcolor: 'rgba(255, 255, 255, 0.7)',
              }}
              disabled={currentIndex === maxIndex}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </>
        )}
        <Box
          ref={funcionesRef}
          sx={{
            display: 'flex',
            scrollBehavior: 'smooth',
            my: 3,
          }}
        >
          {funcionesConFechas?.map((funcion, i) => (
            <Box
              sx={{ mx: 1, border: `1px solid ${theme.palette.secondary.main}` }}
              key={i}
              onClick={() => handleOnClick(funcion, i)}
            >
              <Card
                className="cardFuncion"
                sx={{
                  boxShadow: 'none',
                  width: '90px',
                  borderRadius: 0,
                  backgroundColor: indexFecha === i || funcion.Id === funcionId ? theme.palette.secondary.main : '',
                  '&:hover': {
                    backgroundColor:
                      indexFecha === i || funcion.Id === funcionId
                        ? theme.palette.secondary.main
                        : 'rgb(233, 232, 232)',
                  },
                }}
              >
                <CardContent sx={{ p: '12px' }}>
                  {/* <CardContent sx={{ pb: 4 }}> */}
                  <Typography variant="body2" component="div">
                    {`${getDiaSemana(funcion.Fecha.FechaInicio)}`}
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    color={indexFecha === i || funcion.Id === funcionId ? 'white' : 'secondary'}
                  >
                    {formatearDateAFechaDiaMesUY(funcion.Fecha.FechaInicio)}
                  </Typography>
                  <Typography variant="body2" component="div">
                    {`${formatearDateAHorasUY(funcion.Fecha.FechaInicio)} hs`}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }
);

export default CarouselFunciones;
